import { render, staticRenderFns } from "./subItem.vue?vue&type=template&id=ba9a1754&scoped=true"
import script from "./subItem.vue?vue&type=script&lang=js"
export * from "./subItem.vue?vue&type=script&lang=js"
import style0 from "./subItem.vue?vue&type=style&index=0&id=ba9a1754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9a1754",
  null
  
)

export default component.exports